<template>
  <base-section
  id="key-dates"
  space="0"
  >
    <v-container>
    <base-section-heading
    title="Key Dates"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
<!--- Submission Deadline (Title and Abstract): <span style="color: #808080"><s>October 30th, 2024</s></span> <span style="color: #d7422b"><strong>November 8th, 2024 <span style="color: red;">(Extended Deadline)</span></strong></span> <br />--->
Submission Deadline (Full Paper, including new submissions): <span style="color: #808080"><s>November 15th, 2024</s></span> <span style="color: #d7422b"><strong>December 3rd, 2024 <span style="color: red;">(Extended Deadline)</span></strong></span><br />
Notification of Acceptance: <span style="color: #d7422b"> <strong>December 28th, 2024</strong></span><br />
Camera Ready: <span style="color: #d7422b"><strong>January 10th, 2025</strong></span><br />
<!---Advance registration and hotel booking: <span style="color: #d7422b"><strong>February 6th, 2024</strong></span><br />--->

<br>
</strong>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'KeyDates',

    data: () => ({

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
